import { render, staticRenderFns } from "./Atch.vue?vue&type=template&id=6aea855b&"
import script from "./Atch.vue?vue&type=script&lang=js&"
export * from "./Atch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports